<div class="runSetup run-report-items-container" [class.print-mode]="isPrintMode">
  <div class="run-report-items-body">
    @if (isPrintView) {
      <app-print-preview-bar
        viewName="Report Items"
        [studyName]="studyName"
        [contextLine]="printContextLine"
        [tableColumns]="tableColumns"
        (selectColumns)="handlePrintColumnSelection($event)">
      </app-print-preview-bar>
    }
    @if (reportContentFormGroup) {
    @if (!isPrintView) {
    <div class="run-report-items-scroll">
      <div class="report-items-section">
        <div class="flex report-items-layout">
      <div class="report-toolbar">
        <div class="report-toolbar__content bpx-toolbar">
          <div class="bpx-toolbar__actions">
            <button type="button" class="bpx-btn bpx-btn--primary" (click)="storeFormValues()" [disabled]="isUpdated">
              Update Study
            </button>
          </div>
          <div *ngIf="reportContentFormGroup.get('reportContent')" class="bpx-toolbar__actions report-toolbar__actions">
            <button type="button" class="bpx-btn" (click)="addData()">
              Add data
            </button>
            <button type="button" class="bpx-btn bpx-btn--danger" (click)="removeData()"
              [disabled]="!selection.hasValue()">
              Remove data
            </button>
            <button type="button" class="bpx-btn" (click)="autofillFunc()">
              Autofill
            </button>
            <span class="bpx-toolbar__sep"></span>
            <button type="button" class="bpx-btn" (click)="openExcelSelector()" [disabled]="isImporting">
              <mat-icon fontIcon="upload_file"></mat-icon>
              <span>{{ isImporting ? 'Reading…' : 'Upload Excel' }}</span>
            </button>
            <button type="button" class="bpx-btn" (click)="downloadExcelTemplate()">
              <mat-icon fontIcon="download"></mat-icon>
              <span>Download Template</span>
            </button>
            <input #excelSelector type="file" class="report-toolbar__file-input"
              [accept]="excelAcceptedTypes" (change)="handleExcelSelection($event)"
              aria-hidden="true" tabindex="-1">
            <span class="bpx-toolbar__sep"></span>
            <button type="button" class="bpx-btn" [disabled]="(isStudySaved$ | async) !== true" (click)="navigateToPrintView()">
              <mat-icon fontIcon="print"></mat-icon>
              <span>Print View</span>
            </button>
          </div>
          <!-- The count is the rows each kit lot holds, so it resizes the table. Committed on
               change, not per keystroke - see applyAssayCount. -->
          <div class="bpx-count report-toolbar__assay-count">
            <label class="bpx-count__label" for="report-items-assay-count">Number of Assays</label>
            <input
              id="report-items-assay-count"
              class="bpx-count__input"
              type="number"
              min="1"
              integerOnly
              name="reportItemsAssayCount"
              [(ngModel)]="assayCountInput"
              (change)="applyAssayCount()" />
            <span class="bpx-count__steppers">
              <button type="button" class="bpx-count__step" (click)="stepAssayCount(1)"
                aria-label="Add an assay row to every kit lot">
                <mat-icon fontIcon="keyboard_arrow_up"></mat-icon>
              </button>
              <button type="button" class="bpx-count__step" (click)="stepAssayCount(-1)"
                [disabled]="!canDecreaseAssayCount"
                aria-label="Remove an assay row from every kit lot">
                <mat-icon fontIcon="keyboard_arrow_down"></mat-icon>
              </button>
            </span>
          </div>
        </div>
      </div>
      <div *ngIf="reportContentFormGroup.get('reportContent')" class="kitTable" [formGroup]="reportContentFormGroup">
        <div class="bpx-section__head">
          <h3 class="bpx-section__title">Report Items</h3>
          <span class="bpx-section__count">{{ reportContentDataSource.data.length }} {{ reportContentDataSource.data.length === 1 ? 'item' : 'items' }}</span>
        </div>
        <div class="kit-table-scroll bpx-table">
          <!-- data-bpx-fill-across lets the fill handle drag sideways along a row as well as down a
               column, and scrolls this table when a drag reaches its edge. See FillHandleDirective. -->
          <table id="kit-lots" mat-table [dataSource]="reportContentDataSource" formArrayName="reportContent"
            class="mat-elevation-z0" data-bpx-fill-across>
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef class="sticky-col sticky-col-0">
              <mat-checkbox color="warn" (change)="toggleAllRows()" [checked]="isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let element; let rowIndex = index" class="sticky-col sticky-col-0">
              <mat-checkbox color="warn" (click)="$event.stopPropagation()" (change)="toggleRow(rowIndex)"
                [checked]="isRowSelected(rowIndex)" [aria-label]="checkboxLabel(rowIndex)">
              </mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="kitLot">
            <th mat-header-cell *matHeaderCellDef class="sticky-col sticky-col-1">Kit Lot</th>
            <td mat-cell *matCellDef="let element; let rowIndex = index" [formGroupName]="rowIndex"
              class="sticky-col sticky-col-1"
              [bpxFillHandle]="reportContentFormArray.at(rowIndex).get('lot')">
              <mat-select class="drop-down-field text-input" formControlName="lot">
                @for (kitLot of kitLots; track kitLot) {
                <mat-option class="optionWidth" [value]="kitLot" [matTooltip]="kitLot"
                  matTooltipPosition="above">{{kitLot}}</mat-option>
                }
              </mat-select>
            </td>
          </ng-container>

          <ng-container matColumnDef="assayName">
            <th mat-header-cell *matHeaderCellDef class="sticky-col sticky-col-2">Assay Name</th>
            <td mat-cell *matCellDef="let element; let rowIndex = index" [formGroupName]="rowIndex"
              class="sticky-col sticky-col-2"
              [bpxFillHandle]="reportContentFormArray.at(rowIndex).get('assay')">
              <mat-select class="drop-down-field text-input" formControlName="assay"
                (selectionChange)="onAssayChange($event, rowIndex)">
                @for (assayName of assayNames; track assayName) {
                <mat-option class="optionWidth" [value]="assayName" [matTooltip]="assayName"
                  matTooltipPosition="above">{{assayName}}</mat-option>
                }
              </mat-select>
            </td>
          </ng-container>

          <ng-container matColumnDef="runId">
            <th mat-header-cell *matHeaderCellDef>Instrument ID</th>
            <td mat-cell *matCellDef="let element; let rowIndex = index" [formGroupName]="rowIndex"
              [bpxFillHandle]="reportContentFormArray.at(rowIndex).get('runId')">
              <mat-select class="drop-down-field text-input" formControlName="runId">
                @for (runId of runIds; track runId) {
                <mat-option class="optionWidth" [value]="runId" [matTooltip]="runId"
                  matTooltipPosition="above">{{runId}}</mat-option>
                }
              </mat-select>
            </td>
          </ng-container>

          <ng-container matColumnDef="resultType">
            <th mat-header-cell *matHeaderCellDef>Result Type</th>
            <td mat-cell *matCellDef="let element; let rowIndex = index" [formGroupName]="rowIndex"
              [bpxFillHandle]="reportContentFormArray.at(rowIndex).get('resultType')">
              <mat-select class="drop-down-field text-input" formControlName="resultType">
                @for (materialResultType of materialResultTypes; track materialResultType) {
                <mat-option class="optionWidth" [value]="materialResultType" [matTooltip]="materialResultType"
                  matTooltipPosition="above">{{materialResultType}}</mat-option>
                }
              </mat-select>
            </td>
          </ng-container>

          <ng-container matColumnDef="beadRegion">
            <th mat-header-cell *matHeaderCellDef>Bead Region</th>
            <td mat-cell *matCellDef="let element; let rowIndex = index" [formGroupName]="rowIndex"
              [bpxFillHandle]="reportContentFormArray.at(rowIndex).get('region')">
              <mat-select class="drop-down-field text-input" formControlName="region">
                @for (beadRegion of beadRegions; track beadRegion) {
                <mat-option [value]="beadRegion" [matTooltip]="beadRegion.toString()"
                  matTooltipPosition="above">{{beadRegion}}</mat-option>
                }
              </mat-select>
            </td>
          </ng-container>

          <ng-container matColumnDef="beadCouplingDate">
            <th mat-header-cell *matHeaderCellDef>Bead Coupling Date</th>
            <td mat-cell *matCellDef="let element; let rowIndex = index" [formGroupName]="rowIndex"
              [bpxFillHandle]="reportContentFormArray.at(rowIndex).get('beadCouplingDate')">
              <input matInput [matDatepicker]="picker" [readonly]="true" formControlName="beadCouplingDate"
                class="text-input text-centered" (click)="picker.open()">
              <mat-datepicker #picker></mat-datepicker>
            </td>
          </ng-container>

          <ng-container matColumnDef="coupledBeadLn">
            <th mat-header-cell *matHeaderCellDef>Coupled Bead LN</th>
            <td mat-cell *matCellDef="let element; let rowIndex = index" [formGroupName]="rowIndex"
              [bpxFillHandle]="reportContentFormArray.at(rowIndex).get('coupledBeadLn')">
              <input matInput formControlName="coupledBeadLn" class="text-input text-centered" [maxlength]="20">
            </td>
          </ng-container>

          <ng-container matColumnDef="dyedBeadLn">
            <th mat-header-cell *matHeaderCellDef>Dyed Bead LN</th>
            <td mat-cell *matCellDef="let element; let rowIndex = index" [formGroupName]="rowIndex"
              [bpxFillHandle]="reportContentFormArray.at(rowIndex).get('dyedBeadLn')">
              <input matInput formControlName="dyedBeadLn" class="text-input text-centered" [maxlength]="20">
            </td>
          </ng-container>

          <ng-container matColumnDef="progenitorLn">
            <th mat-header-cell *matHeaderCellDef>Progenitor LN</th>
            <td mat-cell *matCellDef="let element; let rowIndex = index" [formGroupName]="rowIndex"
              [bpxFillHandle]="reportContentFormArray.at(rowIndex).get('progenitorLn')">
              <input matInput formControlName="progenitorLn" class="text-input text-centered" [maxlength]="20">
            </td>
          </ng-container>

          <ng-container matColumnDef="antigenLn">
            <th mat-header-cell *matHeaderCellDef>Antigen LN</th>
            <td mat-cell *matCellDef="let element; let rowIndex = index" [formGroupName]="rowIndex"
              [bpxFillHandle]="reportContentFormArray.at(rowIndex).get('antigenLn')">
              <input matInput formControlName="antigenLn" class="text-input text-centered" [maxlength]="20">
            </td>
          </ng-container>

          <ng-container matColumnDef="antigenLoading">
            <th mat-header-cell *matHeaderCellDef>Antigen Loading</th>
            <td mat-cell *matCellDef="let element; let rowIndex = index" [formGroupName]="rowIndex"
              [bpxFillHandle]="reportContentFormArray.at(rowIndex).get('antigenLoadLn')">
              <input matInput formControlName="antigenLoadLn" class="text-input text-centered" [maxlength]="20">
            </td>
          </ng-container>

          <ng-container matColumnDef="coupledBeadPn">
            <th mat-header-cell *matHeaderCellDef>Coupled Bead PN</th>
            <td mat-cell *matCellDef="let element; let rowIndex = index" [formGroupName]="rowIndex"
              [bpxFillHandle]="reportContentFormArray.at(rowIndex).get('coupledBeadPn')">
              <input matInput formControlName="coupledBeadPn" class="text-input text-centered" [maxlength]="20">
            </td>
          </ng-container>

          <ng-container matColumnDef="ligandPn">
            <th mat-header-cell *matHeaderCellDef>Ligand PN</th>
            <td mat-cell *matCellDef="let element; let rowIndex = index" [formGroupName]="rowIndex"
              [bpxFillHandle]="reportContentFormArray.at(rowIndex).get('ligandPn')">
              <input matInput formControlName="ligandPn" class="text-input text-centered" [maxlength]="20">
            </td>
          </ng-container>

          <ng-container matColumnDef="beadReagentPn">
            <th mat-header-cell *matHeaderCellDef>Bead Reagent PN</th>
            <td mat-cell *matCellDef="let element; let rowIndex = index" [formGroupName]="rowIndex"
              [bpxFillHandle]="reportContentFormArray.at(rowIndex).get('beadReagentPn')">
              <input matInput formControlName="beadReagentPn" class="text-input text-centered" [maxlength]="20">
            </td>
          </ng-container>

          <ng-container *ngIf="variableColumnMeta.length">
            <ng-container *ngFor="let column of variableColumnMeta; trackBy: trackVariableColumn" [matColumnDef]="column.id">
              <th mat-header-cell *matHeaderCellDef>
                <div class="mb-2"> {{ column.label }} </div>
                <div *ngIf="column.partNumber"> {{ column.partNumber }} </div>
              </th>
              <td mat-cell *matCellDef="let element; let rowIndex = index" [formGroupName]="rowIndex"
                [bpxFillHandle]="reportContentFormArray.at(rowIndex).get(column.id)">
                <input matInput [formControlName]="column.id"
                  class="text-input text-centered" [maxlength]="20">
              </td>
            </ng-container>
          </ng-container>

          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let element; let rowIndex = index" [formGroupName]="rowIndex"
              [bpxFillHandle]="reportContentFormArray.at(rowIndex).get('description')">
              <input matInput formControlName="description" class="text-input text-centered" [maxlength]="100">
            </td>
          </ng-container>

            <tr mat-header-row *matHeaderRowDef="reportContentColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: reportContentColumns;"></tr>
          </table>
          @if (!reportContentDataSource.data.length) {
          <p class="bpx-empty">No report items yet. Use Add data to create one.</p>
          }
        </div>
      </div>
    </div>
      </div>
    </div>
    } @else if (isPrintView) {
    <div class="print-report-items-preview">
      <table class="print-report-items-table">
        <thead>
          <tr>
            @for (col of selectedPrintColumns; track col.columnKey) {
              @if (col.isSelected) {
                <th>{{ col.columnName }}</th>
              }
            }
          </tr>
        </thead>
        <tbody>
          @for (row of reportContentDataSource.data; track row.reportContentItemId; let i = $index) {
            <tr>
              @for (col of selectedPrintColumns; track col.columnKey) {
                @if (col.isSelected) {
                  <td>{{ getPrintCellValue(i, col.columnKey ?? '') }}</td>
                }
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
    @for (pageCols of printPages; track pageCols; let pageIndex = $index) {
    <div class="print-report-items-page" [class.print-report-items-page--last]="pageIndex === (printPages.length - 1)">
      <table class="print-report-items-table">
        <thead>
          <tr>
            @for (col of pageCols; track col.columnKey) {
              <th>{{ col.columnName }}</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (row of reportContentDataSource.data; track row.reportContentItemId; let i = $index) {
            <tr>
              @for (col of pageCols; track col.columnKey) {
                <td>{{ getPrintCellValue(i, col.columnKey ?? '') }}</td>
              }
            </tr>
          }
        </tbody>
        <tfoot class="bpx-print-spacer-footer">
          <tr>
            <td [attr.colspan]="pageCols.length || 1">
              <div class="bpx-print-footer-spacer" aria-hidden="true"></div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
    }
    }
    } @else if (isEmpty) {
    <div class="loading-container">
      <div class="mb-6">No data found</div>
    </div>
    } @else {
    <div class="loading-container">
      <div><mat-spinner class="spinner"></mat-spinner></div>
      <div>Loading...</div>
    </div>
    }
  </div>
</div>

@if (isPrintMode) {
<div class="header">
  Bio-Rad Laboratories<br />
  Redmond, WA
</div>
<div class="print-footer-cutoff" aria-hidden="true"></div>
<div class="footer">
  <div class="print-footer-left">
    {{ studyName || '-' }}<br />
    {{ (panelName$ | async) || '-' }} : Spec Rev {{ specVersion || '-' }}<br />
    Web App Version: {{ appVersion || '-' }}
  </div>
</div>
}
